import { z } from 'zod';
import { cognitoPasswordSchema } from './common.schema.js';

/**
 * User Schemas - SSOT for user-related data structures
 */

export const UserRoleSchema = z.enum(['admin', 'user', 'viewer']);
export type UserRole = z.infer<typeof UserRoleSchema>;

export const BaseUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string().min(1).max(255),
  role: UserRoleSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type BaseUser = z.infer<typeof BaseUserSchema>;

export const CreateUserRequestSchema = z.object({
  email: z.string().email('Invalid email address'),
  name: z.string().min(1, 'Name is required').max(255, 'Name too long'),
  password: cognitoPasswordSchema,
  role: UserRoleSchema.optional().default('user'),
});
export type CreateUserRequest = z.infer<typeof CreateUserRequestSchema>;

export const UpdateUserRequestSchema = z.object({
  email: z.string().email().optional(),
  name: z.string().min(1).max(255).optional(),
  role: UserRoleSchema.optional(),
});
export type UpdateUserRequest = z.infer<typeof UpdateUserRequestSchema>;

export const UserResponseSchema = BaseUserSchema.omit({ createdAt: true, updatedAt: true }).extend({
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type UserResponse = z.infer<typeof UserResponseSchema>;
